import React, { FC, useEffect } from 'react';
import { findFrameInContainer } from 'utils/htmlUtil';
import useScript from './useScript';

function setFastlinkFrameTitle() {
  const fastlinkFrame = findFrameInContainer('container-fastlink');
  if (fastlinkFrame) {
    fastlinkFrame.title = 'FastLink Integration Frame';
  } else {
    console.error('FastLink frame not found.');
  }
}

interface FastLinkProps {
  fastLinkURL: string;
  accessToken: string;
  YodleeUrl: string;
  configName: string;
  obAppName: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  onClose?: (data: any) => void;
  onEvent?: (data: any) => void;
}

const FastLink: FC<FastLinkProps> = ({
  fastLinkURL,
  accessToken,
  YodleeUrl,
  configName,
  obAppName,
  onSuccess,
  onError,
  onClose,
  onEvent,
}) => {
  useScript(YodleeUrl, () => {
    if ((window as any).fastlink) {
      (window as any).fastlink.close();
      (window as any).fastlink.open(
        {
          fastLinkURL,
          accessToken: `Bearer ${accessToken}`,
          params: {
            configName,
            obAppName,
          },
          onSuccess:
            onSuccess ??
            ((data: any) => {
              console.log(`onSuccess--\n${JSON.stringify(data)}\n END`);
            }),
          onError:
            onError ??
            ((data: any) => console.log(`onError--\n${JSON.stringify(data)}\n END`)),
          onClose:
            onClose ??
            ((data: any) => console.log(`onClose--\n${JSON.stringify(data)}\n END`)),
          onEvent:
            onEvent ??
            ((data: any) => console.log(`onEvent--\n${JSON.stringify(data)}\n END`)),
        },
        'container-fastlink',
      );
      setFastlinkFrameTitle();
    } else {
      console.error('FastLink script is not loaded.');
    }
  });

  useEffect(() => {
    const handleResizeEvent = (event: MessageEvent) => {
      if (
        event.data?.app === 'fastlink' &&
        event.data?.fnToCall === 'resizeIframeWindow' &&
        typeof event.data.height === 'number'
      ) {
        const iframe = document.getElementById('fl-frame') as HTMLIFrameElement;
        if (iframe) {
          const adjustedHeight = event.data.height;
          setTimeout(() => {
            iframe.style.setProperty('height', `${adjustedHeight}px`, 'important');
          }, 0);
        }
      }
    };

    window.addEventListener('message', handleResizeEvent);

    return () => {
      window.removeEventListener('message', handleResizeEvent);

      if ((window as any).fastlink?.close) {
        (window as any).fastlink.close();
      }

      const fastLinkContainer = document.getElementById('container-fastlink');
      if (fastLinkContainer) {
        fastLinkContainer.innerHTML = '';
      }
    };
  }, []);

  return <div id="container-fastlink" style={{ overflowY: 'auto' }}></div>;
};

export default FastLink;
